var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 13.1C10.3632 13.1 13.1 10.3632 13.1 7C13.1 3.63678 10.3633 0.9 7 0.9C3.63674 0.9 0.9 3.63678 0.9 7C0.9 10.3632 3.63678 13.1 7 13.1ZM7 1.89999C9.81276 1.89999 12.1 4.18721 12.1 7C12.1 9.81279 9.81279 12.1 7 12.1C4.18721 12.1 1.89999 9.81279 1.89999 7C1.89999 4.18721 4.18724 1.89999 7 1.89999Z",
    fill: "#E9A5F3",
    stroke: "#E9A5F3",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.31414 8.21039L9.31402 8.2103L7.50155 6.76032V3.80038C7.50155 3.52515 7.27679 3.30039 7.00156 3.30039C6.72632 3.30039 6.50156 3.52515 6.50156 3.80038V7.0004C6.50156 7.15334 6.5718 7.29564 6.68869 7.39015L6.68909 7.39047L8.6886 8.99008C8.68868 8.99015 8.68877 8.99022 8.68885 8.99029C8.78169 9.06543 8.89214 9.1004 9.00156 9.1004C9.14873 9.1004 9.29396 9.03551 9.39168 8.91281C9.5642 8.69759 9.52899 8.38281 9.31414 8.21039Z",
    fill: "#E9A5F3",
    stroke: "#E9A5F3",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.a868e270a58d759e270cb2b16b10667f.svg";
export { ForwardRef as ReactComponent };